import React from "react";
import "./PoweringTomorrow.css";
import heroIllustration from "../assets/images/powering-tomorrow.png.png";
import leafIcon from "../assets/images/leaf-icon.svg";
import ideaIcon from "../assets/images/idea-icon.svg";
import towerIcon from "../assets/images/transmission-tower-icon.svg";
import peopleIcon from "../assets/images/people-icon.svg";

function PoweringTomorrow() {
  const choiceItems = [
    { icon: towerIcon, text: "More investment in distribution infrastructure" },
    { icon: ideaIcon, text: "Greater innovation in customer service" },
    { icon: leafIcon, text: "Cleaner and more flexible power procurement" },
    { icon: peopleIcon, text: "A customer experience shaped by choice" },
  ];

  const todayData = [
    { label: "Distribution structure", value: "Limited choice" },
    { label: "Backup dependence", value: "Diesel generators" },
    { label: "Procurement mix", value: "Conventional-heavy" },
    { label: "Customer experience", value: "Reactive service" },
  ];

  const tomorrowData = [
    { label: "Distribution structure", value: "Consumer choice" },
    { label: "Backup dependence", value: "Reduced diesel use" },
    { label: "Procurement mix", value: "FDRE-led clean power" },
    { label: "Customer experience", value: "Digital-first service" },
  ];

  return (
    <section className="powering-tomorrow">
      <h2 className="powering-tomorrow-title">Powering a better tomorrow</h2>

      <div className="powering-tomorrow-content">
        {/* Left - What choice can enable */}
        <div
          className="choice-card"
          style={{ backgroundImage: `url(${heroIllustration})` }}
        >
          <h3 className="choice-card-title">What choice can enable</h3>
          <div className="choice-list">
            {choiceItems.map((item, index) => (
              <div key={index} className="choice-item">
                <img src={item.icon} alt="" className="choice-item-icon" />
                <p className="choice-item-text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right - Today & Tomorrow */}
        <div className="comparison-cards">
          <div className="comparison-card today-card">
            <div className="comparison-card-header">
              <h3 className="comparison-card-title">Today</h3>
              <span className="comparison-card-icon">🕒</span>
            </div>
            <div className="comparison-rows">
              {todayData.map((item, index) => (
                <div key={index} className="comparison-row">
                  <span className="comparison-label">{item.label}</span>
                  <span className="comparison-value">{item.value}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="comparison-card tomorrow-card">
            <div className="comparison-card-header">
              <h3 className="comparison-card-title">Tomorrow</h3>
              <span className="comparison-card-icon">🚀</span>
            </div>
            <div className="comparison-rows">
              {tomorrowData.map((item, index) => (
                <div key={index} className="comparison-row">
                  <span className="comparison-label">{item.label}</span>
                  <span className="comparison-value">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PoweringTomorrow;
